import React from 'react';
import PropTypes from 'prop-types';
import style from './index.css';
import CardStream from '../../../components/cardStream';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { newsstream, columnId, isEnd } = content;

        /**
         * 组件分发数据
         */

        return (
            <div className={style.wrap_1000w}>
                <div className={style.list}>
                    <CardStream
                        isPic={false}
                        isScrollLoadingData={true}
                        content={newsstream}
                        columnId={columnId}
                        isEnd={isEnd}
                    />
                </div>
            </div>
        );
    }
}

export default Content;
